import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectPayment } from 'src/store/slice/payment/state';
import { selectCreatedQuote } from 'src/store/slice/quote/state';
import { selectMarketPrice } from 'src/store/slice/marketPrice/state';

import { EPaymentStatus } from 'src/type';

const useCustomTimer = (func: any, deps: any) => {
  const payment = useSelector(selectPayment);
  const createdQuote = useSelector(selectCreatedQuote);
  const marketPrice = useSelector(selectMarketPrice);

  const { client_status } = payment || {};
  const { expiration } = createdQuote || marketPrice || {};

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (client_status === EPaymentStatus.Completed) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    if (expiration && expiration !== 0 && client_status !== EPaymentStatus.Completed) {
      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        func();
      }, Number(expiration) * 1000);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, deps);
};

export { useCustomTimer };
